import { pharmacyClient } from "@/connect";
import { CustomerProfitabilityReportResponse } from "@/gen/reports/customer_profitability_report_pb";


export const getCustomerRevenue = async (
    page: number,
    pageSize: number
  ): Promise<CustomerProfitabilityReportResponse> => {
    return await pharmacyClient.customerProfitabilityReport({
      pageNumber: page,
      pageSize: pageSize,
    });
  };